import { Injectable, computed, type Signal } from '@angular/core';
import { injectCurrentUser } from '@assist/shared/data';
import type { FeatureFlags } from '@cue/api';

export type AssistFeatureName = keyof FeatureFlags;

@Injectable({
  providedIn: 'root',
})
export class AssistFeaturesService {
  private readonly currentUser = injectCurrentUser();

  hasFeature(featureName: AssistFeatureName | Signal<AssistFeatureName>): Signal<boolean> {
    return computed(() => {
      const resolvedFeatureName = typeof featureName === 'function' ? featureName() : featureName;

      return Boolean(this.currentUser()?.data?.features?.[resolvedFeatureName]);
    });
  }
}
